import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@material-ui/core'
import {
  getCategoriaPresupuesto,
  getMasterDetailSubProyect,
} from '../../../../../services/Elegibilidad/get'
import { insertSubprojectBudget } from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import { useFormik } from 'formik'
import NumberFormat from 'react-number-format'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import * as Yup from 'yup'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

export const Modal54 = ({ openSec54, setOpenSec54, getDataTableMaster }) => {
  const { idElegibilityForm } = useFormElegibilidad()
  const [categoryList, setCategoryList] = useState([])
  const [warning, setWarning] = useState(false)
  const [warningCategory, setWarningCategory] = useState(false)
  const [loading, setLoading] = useState(false)
  const [errorDescription, setErrorDescription] = useState(false)
  const [errorUnidad, setErrorUnidad] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    description: Yup.string()
      .required('Este Campo es obligatorio')
      .max(100, 'Max 100 caracteres')
      .matches(
        /^[-,.()\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    unit: Yup.string()
      .required('Este Campo es obligatorio')
      .max(50, 'Max 50 caracteres')
      .matches(
        /^[-,.()\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      ),
    cant: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    unitCost: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    idCategory: Yup.number()
      .required('Este Campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    loand: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    pymeContribution: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    otherContributions: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      unit: '',
      cant: '',
      unitCost: '',
      loand: '',
      pymeContribution: '',
      otherContributions: '',
      categoryList: '',
      description: '',
      idCategory: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: () => {
      handleGuardar()
    },
  })

  const getDataCategory = async (e) => {
    const body = {
      IdElegibilityAnswer: idElegibilityForm,
      IdCategory: e.target.value,
    }
    try {
      const response = await getMasterDetailSubProyect(body)
      if (response.Success) {
        if (response.Data.length >= 3) {
          swal({
            title: 'No se permiten más registros en esa categoría',
            icon: 'warning',
            button: 'Entendido',
          })
          setWarningCategory(true)
        } else {
          setWarningCategory(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getListCategory = async () => {
    try {
      const response = await getCategoriaPresupuesto()
      setCategoryList(response.Data)
    } catch (error) {
      console.log(error)
    }
  }

  let totalCost =
    formik.values.unitCost !== '' &&
    formik.values.cant !== '' &&
    isNaN(formik.values.unitCost) === false &&
    isNaN(formik.values.cant) === false
      ? formik.values.unitCost * formik.values.cant
      : 0

  let sum =
    formik.values.loand !== '' &&
    formik.values.pymeContribution !== '' &&
    formik.values.otherContributions !== '' &&
    isNaN(formik.values.loand) === false &&
    isNaN(formik.values.pymeContribution) === false &&
    isNaN(formik.values.otherContributions) === false
      ? formik.values.loand +
        formik.values.pymeContribution +
        formik.values.otherContributions
      : 0

  useEffect(() => {
    getListCategory()
  }, [])

  const handleGuardar = async () => {
    if (sum.toFixed(2) === totalCost.toFixed(2)) {
      setLoading(true)

      const body = {
        IdSubprojectBudget: 0,
        IdElegibilityAnswer: idElegibilityForm,
        IdCategory: formik.values.idCategory,
        Description: formik.values.description,
        Unit: formik.values.unit,
        Quantity: formik.values.cant,
        UnitCost: formik.values.unitCost,
        TotalCost: totalCost,
        LoanContribution: formik.values.loand,
        MIPYMEContribution: formik.values.pymeContribution,
        OtherContributions: formik.values.otherContributions,
      }

      const response = await insertSubprojectBudget(body)
      if (response.Success) {
        swal({
          title: '¡Datos guardados exitosamente!',
          icon: 'success',
        })

        getDataTableMaster()
        handleClose()
      }
    } else {
      setWarning(true)
    }
  }

  const handleClose = () => {
    setOpenSec54(false)

    totalCost = ''
    sum = ''
    formik.resetForm()
    setLoading(false)
    setWarning(false)
    setErrorDescription(false)
    setErrorUnidad(false)
  }
  return (
    <>
      <Modal
        open={openSec54}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos del presupuesto</h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Categoria</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="IdProject"
                    name="IdProject"
                    variant="outlined"
                    error={formik.errors.idCategory}
                    value={formik.values.idCategory}
                    displayEmpty={true}
                    onChange={(e) => {
                      formik.setFieldValue('idCategory', e.target.value)
                      getDataCategory(e)
                    }}
                  >
                    <MenuItem disabled value="">
                      Seleccione una opción
                    </MenuItem>
                    {categoryList.map &&
                      categoryList.map((item, key) => (
                        <MenuItem key={key} value={item.IdDataField}>
                          {item.FieldDescription}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {formik.errors.idCategory ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idCategory}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Descripción</label>
                    <a
                      data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <TextField
                        id="description"
                        name="description"
                        error={formik.errors.description}
                        value={formik.values.description}
                        autoComplete="off"
                        variant="outlined"
                        allowNegative={false}
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorDescription(false)
                            formik.setFieldValue('description', e.target.value)
                          } else {
                            setErrorDescription(true)
                          }
                        }}
                        inputProps={{
                          maxLength: '100',
                        }}
                      />
                      {errorDescription ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                    </FormControl>
                    {formik.errors.description ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Unidad</label>
                    <a
                      data-tip="Se refiere a la unidad de medida de la producción (Quintales, toneladas, etc.) <br/>  Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <TextField
                        id="Unidad"
                        name="Unidad"
                        error={formik.errors.unit}
                        value={formik.values.unit}
                        autoComplete="off"
                        variant="outlined"
                        allowNegative={false}
                        onChange={(e) => {
                          if (
                            e.target.value.match(
                              /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                            ) ||
                            e.target.value === ''
                          ) {
                            setErrorUnidad(false)

                            formik.setFieldValue('unit', e.target.value)
                          } else {
                            setErrorUnidad(true)
                          }
                        }}
                        inputProps={{
                          maxLength: '50',
                        }}
                      />
                    </FormControl>
                    {errorUnidad ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                    {formik.errors.unit ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.unit}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Cantidad</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          allowLeadingZeros={false}
                          error={formik.errors.cant}
                          id="Cantidad"
                          name="Cantidad"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.cant}
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'cant',
                              parseInt(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          inputProps={{ maxLength: 14 }}
                          decimalScale={0}
                        />
                      </FormControl>
                      {formik.errors.cant ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.cant}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Costo Unitario</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="UnityCost"
                          allowLeadingZeros={false}
                          name="UnityCost"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.unitCost}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          error={formik.errors.unitCost}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'unitCost',
                              parseFloat(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                          decimalScale={2}
                          fixedDecimalScale
                        />
                      </FormControl>
                      {formik.errors.unitCost ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.unitCost}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Costo Total</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="TotalCost"
                          allowLeadingZeros={false}
                          name="TotalCost"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={totalCost.toFixed(2)}
                          autoComplete="off"
                          variant="outlined"
                          disabled
                          allowNegative={false}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid container>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Aportes</label>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Préstamo</label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="TotalCost"
                        name="TotalCost"
                        customInput={TextField}
                        allowLeadingZeros={false}
                        thousandSeparator={true}
                        value={formik.values.loand}
                        error={formik.errors.loand}
                        autoComplete="off"
                        variant="outlined"
                        allowNegative={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'loand',
                            parseFloat(e.target.value.replaceAll(',', '')),
                          )
                        }}
                        isNumericString={true}
                        inputProps={{ maxLength: 18 }}
                        decimalScale={2}
                        fixedDecimalScale
                      />
                    </FormControl>
                    {formik.errors.loand ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.loand}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">MIPYME</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="MIPYME"
                          name="MIPYME"
                          customInput={TextField}
                          allowLeadingZeros={false}
                          thousandSeparator={true}
                          value={formik.values.pymeContribution}
                          error={formik.errors.pymeContribution}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'pymeContribution',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                          decimalScale={2}
                          fixedDecimalScale
                        />
                      </FormControl>
                      {formik.errors.pymeContribution ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.pymeContribution}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Otros Aportes</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="Other"
                          name="Other"
                          customInput={TextField}
                          allowLeadingZeros={false}
                          thousandSeparator={true}
                          value={formik.values.otherContributions}
                          error={formik.errors.otherContributions}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'otherContributions',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          decimalScale={2}
                          isNumericString={true}
                          inputProps={{ maxLength: 18 }}
                          fixedDecimalScale
                        />
                      </FormControl>
                      {formik.errors.pymeContribution ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.pymeContribution}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {warning ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  La sumatoria de los montos de aportes préstamo, MIPYME y otros
                  aportes debe ser igual al monto costo total
                </div>
              ) : null}
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>

                {/* <Button
                  className={!warningCategory ? 'confirmButton' : ''}
                  type="submit"
                  onClick={validateFormStatus}
                  disabled={warningCategory || loading}
                >
                  Guardar
                </Button> */}

                {loading === false ? (
                  <Button
                    className={!warningCategory ? 'confirmButton' : ''}
                    type="submit"
                    onClick={validateFormStatus}
                    disabled={warningCategory}
                  >
                    Guardar
                  </Button>
                ) : (
                  <Button className={'confirmButton'} type="submit" disabled>
                    Guardar
                  </Button>
                )}
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
